/**
* 生成订单
*/
<template>
  <div>

    <div class="wrapper">

      <el-steps :active="1">
        <el-step title="生成订单"></el-step>
        <el-step title="支付订单"></el-step>
        <el-step title="支付成功"></el-step>
      </el-steps>

      <div class="content-wrapper">
        <!--        <div class="content-head">-->
        <!--          订单详情-->
        <!--        </div>-->

        <div class="content">

          <div class="item">

            <span>产品信息:</span>

            <div class="item-content">
              QPS包
            </div>

          </div>

          <div class="item">

            <span>类型:</span>

            <div class="item-content">

              <div class="button" :class="activeClass== index ? 'active':''" v-for="(item,index) in itemList"
                   :key="index" @click="getItem(index,item)">{{ item.alias }}
              </div>

            </div>

          </div>


          <div class="item">

            <span>规格:</span>

            <div class="item-content-price">


              <div class="button-price" :class="priceActiveClass== index ? 'active':''"
                   v-for="(item,index) in priceItemList" :key="index" @click="getPriceItem(index)">

                <div>¥{{ item.goodsPrice }}</div>
                <div>/{{ item.goodsCategory }}</div>

                <div class="check">
                </div>

              </div>


            </div>

          </div>

          <div class="item">

            <span>说明:</span>

            <div class="item-content">
              {{ tips }}
            </div>

          </div>


        </div>
      </div>

      <div class="foot">

        <div>
          <span>费用合计：</span>
          <span>¥{{ this.priceItemList[this.priceActiveClass].goodsPrice }}</span>
        </div>

        <div class="buy">

          <div>
            <el-checkbox v-model="checked"><span>阅读并同意</span>
              <router-link to="/protocol/api">UbiBoat API使用协议</router-link>
            </el-checkbox>
          </div>
          <div class="buy-button">
            <el-button plain :disabled="!checked" @click="creatOrder()">立即购买</el-button>
          </div>

        </div>

      </div>

    </div>


  </div>

</template>


<script>
import {getGoodsList} from '../../api/payMG'

export default {
  data() {
    return {
      checked: false,
      activeClass: 0,
      apiActiveClass: 0,
      priceActiveClass: 0,
      itemList: [
        {
          content: 'QPS包50次/秒',
          tips: "购买时长中每个月以31天计算",
          alias: "50次/秒"

        },
        {
          content: 'QPS包100次/秒',
          tips: "购买时长中每个月以31天计算",
          alias: "100次/秒"
        },
        {
          content: 'QPS包200次/秒',
          tips: "购买时长中每个月以31天计算",
          alias: "200次/秒"
        }
      ],
      priceItemList: [],
      title: "",
      tips: ""
    };
  },
  methods: {
    getItem(index, item) {
      this.activeClass = index;  // 把当前点击元素的index，赋值给activeClass

      this.getGoodsListItem(item.content);

      this.title = this.itemList[index].content;
      this.tips = this.itemList[index].tips;
      this.priceActiveClass = 0;
    },
    getApiItem(index) {
      this.apiActiveClass = index;
    },
    getPriceItem(index) {
      this.priceActiveClass = index;
    },

    getGoodsListItem(params) {
      getGoodsList(params).then(response => {

        console.log(response)

        if (response.status != 200) {
          this.$message.error("网络异常，请稍后再试")
        } else {
          this.priceItemList = response.data;
        }
      }).catch(e => {
          console.log(e)
          this.$message.error("网络异常，请稍后再试")
        }
      )

    },
    creatOrder() {

      this.$router.push({
        path: '/pay/payOrder', query: {
          goodsId: this.priceItemList[this.priceActiveClass].goodsId,
          applicationId: this.$route.query.applicationId
        }
      })

    }
  },
  created() {

    this.activeClass = 0;
    this.apiActiveClass = 0;
    this.title = this.itemList[0].content;
    this.tips = this.itemList[0].tips;
    this.getGoodsListItem(this.title)
  },

};


</script>

<style scoped>

.wrapper {
  padding: 2vw 3vw;
}


.content-head {
  margin: 1vw 2vw;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: start;
  background-color: white;
  margin-top: 2vw;
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: start;

}

.item {
  display: flex;
  margin: 1vw 2vw;
  width: 70vw;
  justify-content: start;
  align-items: center;
}

.item span {
  margin-right: 2vw;
  width: 6vw;
}


.item-content {
  display: flex;
  justify-content: start;

  flex-wrap: wrap;
}

.item-content-price {
  display: flex;
  justify-content: start;
  align-items: center;
  flex-wrap: wrap;

}

.button {
  width: 12vw;
  height: 2.5vw;
  line-height: 2.5vw;
  color: gray;
  text-align: center;

  background: #fff;
  border: 1px solid #ededed;

  border-radius: 0.1vw 0 0 0.1vw;
  margin: 0.2vw 0.2vw;
  cursor: pointer;
}

.button.active {
  background-color: #3a8ee6;
  color: white;
}

.button-price {
  width: 15vw;
  height: 8vw;
  line-height: 8vw;
  margin: 1vw 1vw;
  color: #ff5252;
  box-shadow: 0 0 0.6vw rgb(0 0 0 /12%);
  border-radius: 0.3vw;
  display: flex;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
}

.button-price .check {
  width: 0;
  height: 0;
  border-bottom: 1.8vw solid #3a8ee6;
  border-right: 1.8vw solid transparent;
  position: absolute;
  left: -0.05vw;
  bottom: -0.05vw;
  display: none;
}


.button-price.active {
  border: 0.2vw #3a8ee6 solid;
}

.button-price.active .check {
  display: block;

}


.button-price.active .check:before {
  content: "";
  width: 0.2vw;
  height: 1vw;
  background: white;
  left: 0.7vw;
  bottom: -2.05vw;
  position: absolute;
  transform: rotate(38deg);
  border-radius: 0.01vw;
}

.button-price.active .check:after {
  content: "";
  width: 0.21vw;
  height: 0.79vw;
  background: white;
  left: 0.17vw;
  bottom: -2.2vw;
  position: absolute;
  transform: rotate(-52deg);
  border-radius: 0.01vw;
}

.button-price div:first-child {
  font-size: 1.8vw;
  font-weight: 400;
}

.button-price div:last-child {
  font-size: 0.8vw;
}

.foot {
  background-color: white;
  margin-top: 2vw;
  height: 8vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 3vw;
}


.buy {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.buy-button {
  margin-top: 1vw;
}

.buy a {
  text-decoration: none;
  color: #3a8ee6;
}

.foot span:last-child {
  color: #ff5252;
  font-size: 1.8vw;
}


</style>




// WEBPACK FOOTER //
// src/views/pay/CreateOrderQps.vue